module.exports = __webpack_public_path__ + "static/media/back_1.10a134b1.png";